import { api, getApiUrl } from 'utils/api';
import { RatingResponse, RatingSummaryResponse, SubmitRatingRequest } from './notice';

const BASE_URL = getApiUrl('');

export const interventionPlanAdminApi = {
  getRatings: (noticeId: number): Promise<RatingSummaryResponse> =>
    api(`${BASE_URL}/notices/${noticeId}/ratings`, { method: 'GET' }),
};

export const interventionPlanIntervenerApi = {
  submitRating: (planId: number, request: SubmitRatingRequest): Promise<RatingResponse> =>
    api(`${BASE_URL}/interveners/me/intervention-plans/${planId}/rating`, {
      method: 'POST',
      payload: request,
    }),

  getMyRating: async (planId: number): Promise<RatingResponse | null> => {
    const response = await api(`${BASE_URL}/interveners/me/intervention-plans/${planId}/rating`, {
      method: 'GET',
    });
    return response && 'stars' in response ? response : null;
  },
};
